import type { RootState } from '../store/types';

export const messagesSelector = {
  messages: (state: RootState) => state.popup,
};
